import * as Yup from 'yup';

const userIdSchema = Yup.object({
  operation: Yup.object({
    type: Yup.string().required('Please select an operation'),
    setId: Yup.string().notRequired(),
    operand: Yup.string().when(['setId', 'type'], (values) => {
      if (!values) {
        return Yup.mixed().required();
      }
      const [setId, type] = values;

      if (setId) {
        return Yup.mixed().notRequired();
      }
      if (!type) {
        return Yup.mixed().notRequired();
      }
      if (type.includes('Contains')) {
        return Yup.array().of(Yup.string()).nullable().required('Please enter a user id value');
      }
      return Yup.string().required('Please enter a user id value');
    }),
  }).required(),
}).when('type', (type, schema) => (type === 'UserId' ? schema : Yup.mixed().notRequired()));

const eventOccurredSchema = Yup.object({
  eventName: Yup.string().required('Please select an event'),
  operation: Yup.object({
    type: Yup.string().required('Please select rule'),
    operand: Yup.string().when('type', (type) =>
      type && type.includes('relative')
        ? Yup.string().matches(/[0-9.]+/, 'Please enter a valid number of days')
        : Yup.mixed().notRequired(),
    ),
    operandDate: Yup.string().when('type', (type) =>
      type && type.includes('absolute')
        ? Yup.string().nullable().required('Please select a date')
        : Yup.mixed().notRequired(),
    ),
  }).required(),
}).when('type', (type, schema) => (type === 'EventOccurred' ? schema : Yup.mixed().notRequired()));

const userSeenSchema = Yup.object({
  operation: Yup.object({
    type: Yup.string().required('Please select rule'),
    operand: Yup.string().when('type', (type) =>
      type && type.includes('relative')
        ? Yup.string().required('Please enter a valid number of days')
        : Yup.mixed().notRequired(),
    ),
    operandDate: Yup.string().when('type', (type) =>
      type && type.includes('absolute')
        ? Yup.string().nullable().required('Please select a date')
        : Yup.mixed().notRequired(),
    ),
  }).required(),
}).when('type', (type, schema) =>
  type === 'FirstSeen' || type === 'LastSeen' ? schema : Yup.mixed().notRequired(),
);

const contentSchema = Yup.object({
  operation: Yup.object({
    type: Yup.string().required('Please select an operation'),
    operand: Yup.string().when('type', (type) =>
      type ? Yup.string().nullable().required('Please select a date') : Yup.mixed().notRequired(),
    ),
  }).required(),
}).when('type', (type, schema) =>
  type === 'LimitedTimeContent' ? schema : Yup.mixed().notRequired(),
);

const userPropertySchema = Yup.object({
  operation: Yup.object({
    type: Yup.string().required('Please select an operation'),
    operand: Yup.string().when(['setId', 'type'], (setId, type) => {
      if (setId) {
        return Yup.mixed().notRequired();
      }
      if (!type) {
        return Yup.mixed().notRequired();
      }
      if (type.includes('Exists')) {
        return Yup.mixed().notRequired();
      }
      if (type.includes('Contains')) {
        return Yup.array().of(Yup.string()).nullable().required('Please set a value');
      }
      return Yup.string().required('Please set a value');
    }),
  }).required(),
}).when('type', (type, schema) => (type === 'UserProperty' ? schema : Yup.mixed().notRequired()));

const singleDefinitionSchema = Yup.object({
  type: Yup.string().required('Must specify a type'),
  not: Yup.bool(),
  UserId: userIdSchema,
  EventOccurred: eventOccurredSchema,
  UserSeen: userSeenSchema,
  LimitedTimeContent: contentSchema,
  UserProperty: userPropertySchema,
});

const nestedGroupsSchema = Yup.object({
  groups: Yup.array().of(
    Yup.lazy((group) =>
      group.object === 'Single'
        ? singleDefinitionSchema
        : Yup.object({ groups: Yup.array().of(singleDefinitionSchema) }),
    ) as any,
  ),
});

export const validationSchema = Yup.object({
  definition: Yup.lazy(({ object }) =>
    object === 'Single' ? singleDefinitionSchema : nestedGroupsSchema,
  ),
});
